import { VpnAccountActions } from "@dots-crm/contracts/client";

export const VPN_ACCOUNT_ENDPOINTS_URLS = {
  create: "vpn-account",
  readMany: "vpn-account",
  readOne: ({ vpnAccountId }: VpnAccountActions["readOne"]["params"]) =>
    `vpn-account/${vpnAccountId}`,
  delete: ({ vpnAccountId }: VpnAccountActions["delete"]["params"]) =>
    `vpn-account/${vpnAccountId}`,
  import: "vpn-account/import",
  importTemplate: "vpn-account/import/template",
  export: (type: "vmess" | "ssh") => `vpn-account/export?type=${type}`,
};

export const VPN_ACCOUNT_TAGS = {
  vpnAccount: "vpnAccount",
};
